import { Component, inject } from '@angular/core'
import { NgTemplateOutlet } from '@angular/common'
import { BricksCardComponent } from '@enbw_bricks/ui'
import { CONTACT_EMAIL } from '../../constants'
import { IndicativeOfferService } from '../../shared/services/indicative-offer.service'
import { OfferFormService } from '../../shared/services/offer-form.service'
import { PRODUCT } from '../../shared/models/price'
import { ProductConfigurationService } from '../../shared/services/product-configuration.service'

@Component({
  selector: 'app-success-message',
  imports: [NgTemplateOutlet, BricksCardComponent],
  templateUrl: './success-message.component.html',
  styleUrl: './success-message.component.scss',
})
export class SuccessMessageComponent {
  private readonly offerFormService = inject(OfferFormService)
  private readonly indicativeOfferService = inject(IndicativeOfferService)
  private readonly productConfigurationService = inject(ProductConfigurationService)
  protected readonly requestId = this.indicativeOfferService.requestId
  protected readonly partnerEmail = this.offerFormService.contactData.controls.contactInfoEmail.value
  protected readonly hasPrice = this.offerFormService.priceData.controls.price.value != null
  protected readonly smallDV =
    this.productConfigurationService.classifyProduct(this.offerFormService.generalData.getRawValue()) ===
    PRODUCT.SMALL_DV

  protected readonly contactEmail = CONTACT_EMAIL
  protected readonly smallDvPriceVariantSteps = [
    'Zugang zum Portal einrichten',
    'Daten überprüfen & vervollständigen',
    'Vertragsdokument erhalten',
  ]

  private readonly directMarketingUrl = 'https://www.interconnector.de/direktvermarktung-strom/'

  openInfoPage() {
    window.open(this.directMarketingUrl)
  }
}
